import isNumber from './is-number';
var isDecimal = function (num) {
    return isNumber(num) && num % 1 !== 0;
};
export default isDecimal;
//# sourceMappingURL=is-decimal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-decimal.js
// module id = 487
// module chunks = 3